document.addEventListener("DOMContentLoaded", function () {
  const burger = document.getElementById("burger");
  const menu = document.getElementById("menu");
  const listItems = document.querySelectorAll(".menu-content-wrapper li");
  burger.addEventListener("click", function () {
    burger.classList.toggle("active");
    menu.classList.toggle("active");
    document.documentElement.classList.toggle("menu-active");
  });

  listItems.forEach((item) => {
    item.addEventListener("click", () => {
      burger.classList.remove("active");
      menu.classList.remove("active");
      document.documentElement.classList.remove("menu-active");
    });
  });
});
